module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The last chord has died away. In the brief silence which follows I feel strongly that there it is, that something has happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Jean-Paul Sartre")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Don’t you ever listen to the radio when the big bad beat comes on?")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Bob Seger")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8fe8f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epi.vue
// module id = 69
// module chunks = 0